<template>
    <main id="Central__Calendar" class="page-layout">
        <div class="mt-2 rounded task-manager-header">Employee Task Manager</div>

        <main class="card px-0 h-100" id="App__Calendar">
            <ListLayout
                :has-title="hideTitle"
                :page-title="employeeName"
                form-title="Bulk Reassign"
                :show-form="isAddItemRequested"
            >
                <!-- FORM CONTENT -->
                <template v-slot:list-form v-if="selectedTaskId.length">
                    <!-- continue from here -->
                    <EmployeeBulkReassign
                        :application="application"
                        :agency-id="agencyId"
                        :user-id="userId"
                        :selected-task-id="selectedTaskId"
                        :close-reassign-form="closeReassignForm"
                        :page-reset="pageReset"
                        :date-from="dateFrom"
                        :date-to="dateTo"
                        :branch-id="branchIds"
                    />
                </template>
                <!-- HEADER CONTENT -->
                <template v-slot:list-header>
                    <div class="d-flex flex-wrap flex-xl-nowrap w-100">
                        <div class="d-flex flex-wrap align-items-center flex-lg-nowrap p-0 m-0 w-100">
                            <div class="form-group me-2 mb-2 flex-shrink-1">
                                <label for="agency-location-id"> Branch </label>
                                <select
                                    id="Referral_Agency_Branch"
                                    name="agency-location-id"
                                    class="form-select"
                                    v-model="branchId"
                                    @change="branchUpdated(branchId)"
                                >
                                    <option :value="null" v-if="branchList.length != 1">All</option>
                                    <option v-for="branch of branchList" :value="branch.id" :key="branch.id">
                                        {{ branch.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group me-2 mb-2">
                                <label for="client-list"> Client </label>
                                <MultiSelectFilter
                                    id="client-list"
                                    :on-fetch="userCredentialsFetch"
                                    :selected-items="selectedClients"
                                    v-on:selectedItemsUpdated="selectedItemsUpdated"
                                    name="Clients"
                                />
                            </div>
                            <div class="form-group me-2 mb-2 flex-shrink-1">
                                <div>
                                    <label for="dateFrom">Date From:</label>
                                    <DatePicker :getDate="changeDate">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                type="text"
                                                class="form-control"
                                                name="dateFrom"
                                                :value="formatDateInput(dateFrom)"
                                                @change="handleDateInputChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                            </div>
                            <div class="form-group me-2 mb-2 flex-shrink-1">
                                <div>
                                    <label for="dateTo">Date To:</label>
                                    <DatePicker :getDate="changeDate">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                type="text"
                                                class="form-control"
                                                name="dateTo"
                                                :value="formatDateInput(dateTo)"
                                                @change="handleDateInputChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                            </div>
                            <div class="form-group mb-2">
                                <div>
                                    <label for="date-to">Filter by text:</label>
                                    <div class="input-group">
                                        <input
                                            type="text"
                                            class="form-control border-end-0"
                                            placeholder="Start Typing"
                                            v-model="term"
                                        />
                                        <span class="input-group-append">
                                            <div class="input-group-text bg-transparent p-2">
                                                <i class="fas fa-search font-size-sm"></i>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto ms-auto me-0 p-0 mt-auto mb-auto">
                            <button
                                type="button"
                                :disabled="selectedTaskId.length === 0"
                                class="btn btn-sm btn-primary ms-2"
                                @click="openReassignForm()"
                            >
                                Reassign
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-primary ms-2"
                                @click="redirectToEmployeeList()"
                            >
                                View Calendar
                            </button>
                        </div>
                    </div>
                </template>
                <div class="table-scroll-wrapper">
                    <table class="table table-responsive-md border border-gray">
                        <thead v-if="!hasData">
                            <tr class="bg-table-header">
                                <th>
                                    <div class="form-check custom-checkbox form-check-inline ms-1 me-0">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            id="task-select-all"
                                            v-model="selectAll"
                                            @change="changeAllSelection()"
                                        />
                                        <label class="form-check-label highlight" for="task-select-all">
                                            <span></span>
                                        </label>
                                    </div>
                                </th>
                                <th>Task Document</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Status</th>
                                <th>Patient</th>
                                <th>Branch</th>
                            </tr>
                        </thead>
                        <thead v-else>
                            <tr class="bg-table-header">
                                <th>
                                    <div class="form-check custom-checkbox form-check-inline ms-1 me-0">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            id="task-select-all"
                                            v-model="selectAll"
                                            @change="changeAllSelection()"
                                        />
                                        <label class="form-check-label highlight" for="task-select-all">
                                            <span></span>
                                        </label>
                                    </div>
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="TaskName"
                                        >Task Document
                                    </SortableTh>
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="StartDate"
                                    >
                                        Date
                                    </SortableTh>
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="StartTime"
                                    >
                                        Time
                                    </SortableTh>
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="Status"
                                    >
                                        Status
                                    </SortableTh>
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="PatientFirstName"
                                    >
                                        Patient
                                    </SortableTh>
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="BranchName"
                                    >
                                        Branch
                                    </SortableTh>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- EMPTY -->
                            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                <td :colspan="columns">
                                    <h3>No Tasks Found.</h3>
                                </td>
                            </tr>
                            <!-- ERROR -->
                            <tr class="table-error" v-if="!isLoading && isError">
                                <td :colspan="columns">
                                    <ErrorMessageHandler title="Inquiry list" v-on:try-again="pageReset()" />
                                </td>
                            </tr>
                            <!-- LOADING -->
                            <template v-if="isLoading">
                                <tr v-for="i of loadingCount" class="table-loading" :key="i">
                                    <td v-for="i of columns" :key="i">
                                        <span class="shimmer-loading"></span>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                        <!-- LIST -->
                        <template v-if="!isLoading && !isError && hasData">
                            <tbody>
                                <tr
                                    v-for="task of filteredTasks"
                                    :key="task.Id"
                                    :class="`${selectedTaskId.includes(task.Id) ? 'select-row' : ''}`"
                                >
                                    <td>
                                        <div
                                            class="form-check custom-checkbox form-check-inline ms-1 zindex-0"
                                            v-if="!isReadOnlyTask(task)"
                                        >
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                :id="`task_${task.Id}`"
                                                :value="task.Id"
                                                v-model="selectedTaskId"
                                                @click="taskChanged($event)"
                                            />
                                            <label class="form-check-label" :for="`task_${task.Id}`">
                                                <span></span>
                                            </label>
                                        </div>
                                    </td>
                                    <td>{{ task.TaskName }}</td>
                                    <td>{{ formatDate(task.StartDate, "MM/DD/YY") }}</td>
                                    <td>{{ getVisitTime(task) }}</td>
                                    <td>
                                        <EmptyTextHandler :text="task.Status"></EmptyTextHandler>
                                    </td>
                                    <td>{{ getFullName(task) }}</td>
                                    <td>{{ task.BranchName }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </table>
                </div>
            </ListLayout>
        </main>
    </main>
</template>

<script lang="ts" src="./TaskManager.ts"></script>
<style src="./TaskManager.scss"></style>
